import React from "react";
import { ProfileBody } from "tsi-common-react/src/apps/customer-account/ProfileBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ProfileDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProfileBody {...props} />
    </PageSkeleton>
);
